/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisputeResolutionOutcome } from './DisputeResolutionOutcome';
import {
    DisputeResolutionOutcomeFromJSON,
    DisputeResolutionOutcomeFromJSONTyped,
    DisputeResolutionOutcomeToJSON,
    DisputeResolutionOutcomeToJSONTyped,
} from './DisputeResolutionOutcome';
import type { DisputePenaltyInput } from './DisputePenaltyInput';
import {
    DisputePenaltyInputFromJSON,
    DisputePenaltyInputFromJSONTyped,
    DisputePenaltyInputToJSON,
    DisputePenaltyInputToJSONTyped,
} from './DisputePenaltyInput';

/**
 * 
 * @export
 * @interface ResolveDisputeBody
 */
export interface ResolveDisputeBody {
    /**
     * 
     * @type {DisputeResolutionOutcome}
     * @memberof ResolveDisputeBody
     */
    resolution: DisputeResolutionOutcome;
    /**
     * New score for team 1 (required for score_adjusted)
     * @type {number}
     * @memberof ResolveDisputeBody
     */
    team1Score?: number;
    /**
     * New score for team 2 (required for score_adjusted)
     * @type {number}
     * @memberof ResolveDisputeBody
     */
    team2Score?: number;
    /**
     * Override winner (for forfeit scenarios)
     * @type {string}
     * @memberof ResolveDisputeBody
     */
    winnerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolveDisputeBody
     */
    adminNotes?: string;
    /**
     * 
     * @type {Array<DisputePenaltyInput>}
     * @memberof ResolveDisputeBody
     */
    penalties?: Array<DisputePenaltyInput>;
}



/**
 * Check if a given object implements the ResolveDisputeBody interface.
 */
export function instanceOfResolveDisputeBody(value: object): value is ResolveDisputeBody {
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    return true;
}

export function ResolveDisputeBodyFromJSON(json: any): ResolveDisputeBody {
    return ResolveDisputeBodyFromJSONTyped(json, false);
}

export function ResolveDisputeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveDisputeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'resolution': DisputeResolutionOutcomeFromJSON(json['resolution']),
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
        'adminNotes': json['adminNotes'] == null ? undefined : json['adminNotes'],
        'penalties': json['penalties'] == null ? undefined : ((json['penalties'] as Array<any>).map(DisputePenaltyInputFromJSON)),
    };
}

export function ResolveDisputeBodyToJSON(json: any): ResolveDisputeBody {
    return ResolveDisputeBodyToJSONTyped(json, false);
}

export function ResolveDisputeBodyToJSONTyped(value?: ResolveDisputeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolution': DisputeResolutionOutcomeToJSON(value['resolution']),
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'winnerId': value['winnerId'],
        'adminNotes': value['adminNotes'],
        'penalties': value['penalties'] == null ? undefined : ((value['penalties'] as Array<any>).map(DisputePenaltyInputToJSON)),
    };
}

